import { get } from 'src/libs/BergCommerceAPI/util';

const GenerateBasketKey = async () => {
    const baseUrl = process.env.WP_API_URL;
    return await get('/cartkeygen', null, baseUrl);
};

export default GenerateBasketKey;